import React, { useEffect, useState } from "react";
import "./sidebar.css";
import { Campaign, Create, AddToQueue, List } from "@mui/icons-material";
import { Link } from "react-router-dom";

const Sidebar = ({ editComp }) => {
  let pathname = window.location.pathname;
  const [allCampaignClass, setallCampaignClass] = useState(true);
  const [createCampaignClass, setcreateCampaignClass] = useState(false);
  const [seriesList, setseriesList] = useState(false);
  const [addProduct, setsaddProduct] = useState(false);
  const [allProduct, setsallProduct] = useState(false);
  // console.log(editComp);
  useEffect(() => {
    switch (pathname) {
      case "/admin":
        setallCampaignClass(true);
        setcreateCampaignClass(false);
        setseriesList(false);
        setsaddProduct(false);
        setsallProduct(false);
        break;

      case "/admin/all-campaign":
        setallCampaignClass(true);
        setcreateCampaignClass(false);
        setseriesList(false);
        setsaddProduct(false);
        setsallProduct(false);
        break;

      case "/admin/create-campaign":
        setallCampaignClass(false);
        setcreateCampaignClass(true);
        setseriesList(false);
        setsaddProduct(false);
        setsallProduct(false);
        break;
      case "/admin/edit-campaign":
        setallCampaignClass(true);
        setcreateCampaignClass(false);
        setseriesList(false);
        setsaddProduct(false);
        setsallProduct(false);
        break;
      case "/admin/campaign-detail":
        setallCampaignClass(false);
        setcreateCampaignClass(false);
        setseriesList(false);
        setsallProduct(false);
        break;
      case "/admin/series-list":
        setallCampaignClass(false);
        setcreateCampaignClass(false);
        setseriesList(true);
        setsaddProduct(false);
        setsallProduct(false);
        break;
      case "/admin/add-products":
        setallCampaignClass(false);
        setcreateCampaignClass(false);
        setseriesList(false);
        setsaddProduct(true);
        setsallProduct(false);
        break;
      case "/admin/all-reward-products":
        setallCampaignClass(false);
        setcreateCampaignClass(false);
        setseriesList(false);
        setsaddProduct(false);
        setsallProduct(true);
        break;

      default:
        return undefined;
    }

    // if(pathname && pathname === '/admin/edit-campaign' ){
    //   setallCampaignClass(false);
    //     setcreateCampaignClass(true)
    // }
  }, [pathname]);

  return (
    <div className="sidebar">
      <div className="sidebarWrapper">
        <div className="sidebarMenu">
          <h3 className="sidebarTitle">Advertisement</h3>
          <ul className="sidebarList">
            {/* <Link to="/admin/all-campaign">
              <li className={`${allCampaignClass === true ? "active" : ""} ${"sidebarListItem"} `} >
                <List className="sidebarIcon" />
                All Campaign
              </li>
            </Link> */}
            <Link to="/admin/all-campaign">
              <li className={` ${ allCampaignClass === true ? "active" : "" } ${"sidebarListItem"} `}>
                <Create className="sidebarIcon " />
                All Campaign
              </li>
            </Link>

            <Link to="/admin/create-campaign">
              <li className={` ${ createCampaignClass === true ? "active" : "" } ${"sidebarListItem"} `}>
                <Create className="sidebarIcon " />
                Create New Campaign
              </li>
            </Link>
          </ul>

          <h3 className="sidebarTitle">Cricway</h3>
          <ul className="sidebarList">
            <Link
              to="/admin/series-list"
              className={` ${
                seriesList === true ? "active" : ""
              } ${"sidebarListItem"} `}
            >
              <li>
                <List className="sidebarIcon" />
                All Series
              </li>
            </Link>
            <Link
              to="/admin/add-products"
              className={` ${
                addProduct === true ? "active" : ""
              } ${"sidebarListItem"} `}
            >
              <li>
                <AddToQueue className="sidebarIcon" />
                Add Products
              </li>
            </Link>

            <Link to="/admin/all-reward-products">
              <li className={` ${
                allProduct === true ? "active" : ""
              } ${"sidebarListItem"} `}>
                <List className="sidebarIcon " />
                All Reward Products
              </li>
            </Link>
            {/* <Link
              to="/admin/all-reward-products"
              className={` ${
                allProduct === true ? "active" : ""
              } ${"sidebarListItem"} `}
            >
              <li>
                <List className="sidebarIcon" />
                All Reward Products
              </li>
            </Link> */}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
